// current device time
// lesson time in New_york => UTC

import dateTime from './date-time';

interface IGTMStamps {
  nowStamp: string;
  firstClassDateStartStamp: string;
  lastClassDateStartStamp: string;
  fixedEndDate: string;
  lastClassDateEndStamp: string;
}

export const getCurrentGTM = () => {
  return dateTime.now().toString();
};

export const endDateFixPmToAm = (sfEndDate: string, sfStartTime: string, sfEndTime: string) => {
  if (sfStartTime.toLowerCase().includes('pm') && sfEndTime.toLowerCase().includes('am')) {
    return dateTime.add(sfEndDate, 1, 'day').format('MM/DD/YYYY');
  }
  return sfEndDate;
};

export const getGTMStamps = (
  sfStartDate: string,
  sfEndDate: string,
  sfStartTime: string,
  sfEndTime: string
): IGTMStamps => {
  const nowStamp = getCurrentGTM();
  const fixedEndDate = endDateFixPmToAm(sfEndDate, sfStartTime, sfEndTime);

  const firstClassDateStartStamp = dateTime
    .getConvertedToEstStamp(dateTime.format(sfStartDate, 'MM/DD/YYYY'), sfStartTime)
    .toString();

  const lastClassDateStartStamp = dateTime.getConvertedToEstStamp(sfEndDate, sfStartTime).toString();
  const lastClassDateEndStamp = dateTime.getConvertedToEstStamp(fixedEndDate, sfEndTime).toString();

  return {
    nowStamp,
    firstClassDateStartStamp,
    lastClassDateStartStamp,
    fixedEndDate,
    lastClassDateEndStamp,
  };
};

export const lessonCategorization = ({ nowStamp, firstClassDateStartStamp, lastClassDateEndStamp }: IGTMStamps) => {
  if (dateTime.isAfter(firstClassDateStartStamp, nowStamp, 'date')) {
    return 'future';
  } else if (dateTime.isBefore(lastClassDateEndStamp, nowStamp, 'date')) {
    return 'past';
  }

  return 'active';
};

export const lessonTiming = (sfNextStartDate: string, sfStartTime: string, sfEndTime: string) => {
  const nowStamp = getCurrentGTM();
  const fixedEndDate = endDateFixPmToAm(sfNextStartDate, sfStartTime, sfEndTime);

  const startDateTimeStamp = dateTime
    .getConvertedToEstStamp(dateTime.format(sfNextStartDate, 'MM/DD/YYYY'), sfStartTime)
    .toString();

  const endDateTimeStamp = dateTime.getConvertedToEstStamp(fixedEndDate, sfEndTime).toString();

  return { nowStamp, startDateTimeStamp, endDateTimeStamp };
};

export const lessonUI = ({ firstClassDateStartStamp, lastClassDateStartStamp, lastClassDateEndStamp }: IGTMStamps) => {
  const timeStamp = `${dateTime.format(firstClassDateStartStamp, 'h:mm A')} - ${dateTime.format(
    lastClassDateEndStamp,
    'h:mm A'
  )}`;

  const dayStamp = `${dateTime.format(firstClassDateStartStamp, 'dddd')}`;

  const dateStamp = `${dateTime.format(firstClassDateStartStamp, 'dddd, MM/DD')} to ${dateTime.format(
    lastClassDateStartStamp,
    'MM/DD/YYYY'
  )}`;
  return { timeStamp, dayStamp, dateStamp };
};
